import {Messages} from '../../constants';

const validation = {
  email: {
    presence: {
      message: Messages.RequiredEmailValidationMessage,
      allowEmpty: false,
    },
    email: {
      message: Messages.InvalidEmailValidationMessage,
    },
  },
  confirmacaoEmail: {
    presence: {
      message: Messages.RequiredEmailConfirmacaoValidationMessage,
      allowEmpty: false,
    },
    equality: {
      attribute: 'email',
      message: Messages.InvalidEmailConfirmacaoValidationMessage,
      comparator: function (v1, v2) {
        return v1.toLocaleLowerCase() === v2.toLocaleLowerCase();
      },
    },
  },
  celular: {
    presence: {
      message: Messages.RequiredCelularValidationMessage,
      allowEmpty: false,
    },
    phone: {
      message: Messages.NumberPhoneIncorrectMessage,
    },
  },
  telefoneResidencial: function (value) {
    if (value) {
      let valueFormatted = value.replace(/[^0-9.]/g, '');
      if (valueFormatted.length < 10 && valueFormatted.length > 0) {
        return {
          phone: {
            message: Messages.TelephoneIncorrectMessage,
          },
        };
      }
      if (/\b(\d)\1+\b/g.test(valueFormatted)) {
        return {
          phone: {
            message: Messages.TelephoneIncorrectMessage,
          },
        };
      }
    }
    return false;
  },
};

export default validation;
